import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

declare var require: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-account-workerplan',
  templateUrl: './workerplan.component.html',
  styleUrl: './workerplan.component.scss'
})
export class WorkerplanComponent implements OnInit {


  features: any;
  recommended: any;
  info:any;
  message_alert: any;
  original: any;
  changed = false;

  formGroup :any;

  submitted = false;


  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.okService.doDismiss('features_menu_badge')

    this.getFeatures();

  }



  getFeatures(){

    this.okService.get("features",{"expand":"features,info,recommended"})
    .subscribe((data:any) => {

      this.features = data.body['features'];
      if(!this.original){
        this.original = data.body['features'];
      }
      this.info = data.body['info'];
      this.recommended = data.body['recommended'];

      //console.log('features',this.features);
      // //console.log('info',this.info);
      // //console.log('billing',this.okService.billing);
      this.setForm();

    })
  }

  setForm(){

    //console.log(this.features);
    //console.log(this.info);

    this.formGroup = new FormGroup({

      // Dashboard
      groups: new FormControl(this.features.groups,[]),
      timesheets: new FormControl(this.features.timesheets,[]),
      worker_reports: new FormControl(this.features.worker_reports,[]),
      safety_awards: new FormControl(this.features.safety_awards,[]),
      live_monitoring: new FormControl(this.features.live_monitoring,[]),
      safety_zones: new FormControl(this.features.safety_zones,[]),
      access: new FormControl(this.features.access,[]),
      auto_end_shift: new FormControl(this.features.auto_end_shift,[]),
      map_zones: new FormControl(this.features.map_zones,[]),
      learning_center: new FormControl(this.features.learning_center,[]),
      action_notices: new FormControl(this.features.action_notices,[]),
      force_password_reset: new FormControl(this.features.force_password_reset,[]),
      privacy_mode: new FormControl(this.features.privacy_mode,[]),

      // Comms Plan
      checkin_reminders: new FormControl(this.features.checkin_reminders,[]),
      out_of_hours: new FormControl(this.features.out_of_hours,[]),
      alert_loops: new FormControl(this.features.alert_loops,[]),
      start_end_shift: new FormControl(this.features.start_end_shift,[]),
      auto_end_sms: new FormControl(this.features.auto_end_sms,[]),
      email_reminder: new FormControl(this.features.email_reminder,[]),
      send_messages: new FormControl(this.features.send_messages,[]),
      status_reply: new FormControl(this.features.status_reply,[]),
      fa2: new FormControl(this.features.fa2,[]),
      flex_delay: new FormControl(this.features.flex_delay),

      // Integrations
      integrations: new FormControl(this.features.integrations,[]),
      spot: new FormControl(this.features.spot,[]),
      zapier: new FormControl(this.features.zapier,[]),
      what3words: new FormControl(this.features.what3words,[]),
      ihelp: new FormControl(this.features.ihelp,[]),
      zoleo: new FormControl(this.features.zoleo,[]),
      teams_notifications: new FormControl(this.features.teams_notifications,[]),
      app_connectivity: new FormControl(this.features.app_connectivity,[]),

      // App features
      timer: new FormControl(this.features.timer,[]),
      checkin: new FormControl(this.features.checkin,[]),
      highrisk: new FormControl(this.features.highrisk,[]),
      mandown: new FormControl(this.features.mandown,[]),
      help: new FormControl(this.features.help,[]),
      shift: new FormControl(this.features.shift,[]),
      shake: new FormControl(this.features.shake,[]),
      timed_activity: new FormControl(this.features.timed_activity,[]),
      panic_button: new FormControl(this.features.panic_button,[]),
      app_links: new FormControl(this.features.app_links,[]),
      sosbutton: new FormControl(this.features.sosbutton,[]),
      fall_detection: new FormControl(this.features.fall_detection,[]),
      two_way_audio: new FormControl(this.features.two_way_audio,[]),

      // Safety Monitoring Center
      enhanced_monitoring: new FormControl(this.features.enhanced_monitoring,[]),
      
    });

    this.formGroup.controls['enhanced_monitoring'].disable();
    this.formGroup.controls['privacy_mode'].disable();

    if(!this.okService.isDemoAccount() && !this.okService.isFromAdmin() && !this.okService.isSuperAdmin()){
      this.formGroup.controls['timer'].disable();
      this.formGroup.controls['checkin'].disable();
      this.formGroup.controls['highrisk'].disable();
      this.formGroup.controls['mandown'].disable();
      this.formGroup.controls['help'].disable();
      this.formGroup.controls['shift'].disable();
      this.formGroup.controls['shake'].disable();
      this.formGroup.controls['timed_activity'].disable();
      this.formGroup.controls['app_links'].disable();
      this.formGroup.controls['sosbutton'].disable();
      this.formGroup.controls['fall_detection'].disable();
      this.formGroup.controls['two_way_audio'].disable();

    }


    


    for (var key in this.info) {
      if(this.features[key] == true){
        this.formGroup.controls[key].disable();
      }

    }

    if(this.okService.isUsDataRegion()){
      this.formGroup.controls['safety_awards'].setValue(false);
      this.formGroup.controls['safety_awards'].disable();
      this.formGroup.controls['learning_center'].setValue(false);
      this.formGroup.controls['learning_center'].disable();
    }


  }

  updateFeatures(features:any){

    //console.log(features);
    this.changed = true;

    this.okService.put("features",{features:features})
    .subscribe((data:any) => {

      //console.log(data.body);

      this.features = data.body['features'];

      this.okService.features = this.features;

      this.setForm();

      this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

      this.okService.toggleMenuUpdate();

    });

  }


  submitForm(){

    this.submitted = true;
    if (
      this.formGroup.valid
      ) {

        let values = _.merge(this.okService.features,this.formGroup.value);
        if(this.okService.isUsDataRegion()){
          values.safety_awards = false;
          values.learning_center = false;
        }
        //console.log(values);

        this.updateFeatures(values);
      }

    return false;
  }

  enableRecommended(){
    this.features = this.recommended;
    this.updateFeatures(this.features);
  }

  enableAll(){

    for (var key in this.features) {
      this.features[key] = true;
    }
    this.updateFeatures(this.features);
  }

  enableUndo(){
    this.features = this.original;
    this.updateFeatures(this.features);

  }

  goToWorker(tab:any){

    // let worker = this.okService.workers[0];
    // this.router.navigateByUrl("/mgmt/worker/"+worker.id+"?tab="+tab);
    this.router.navigateByUrl("/mgmt/workers/workers");

  }

  goToMonitor(){

    let monitor = this.okService.monitors[0];
    this.router.navigateByUrl("/mgmt/monitor/"+monitor.id);


  }


}
